var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.897,
    height: 98.672,
    viewBox: "0 0 104.897 98.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 104.897,
    height: 98.672,
    fill: "#1e61ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M50.523,14.438l-5.2-1.975c-9.5-1.829-22.562-.133-27.948,15.26-6.512,18.617,4,16.839-.9,26.035,0,0-.619,5.227,2.108,7.915l-.013,0s-.573,1.01-1.292,2.625l-2.573-.977a1.766,1.766,0,0,0-1.387.044,1.794,1.794,0,0,0-.96,1.006,1.823,1.823,0,0,0,1.05,2.35l24.915,9.469a1.82,1.82,0,0,0,1.294-3.4l-1.917-.729c.356-1,.7-2.06,1.044-3.194l-.012,0c3.375-.754,5.91-4.4,5.91-4.4,2.442-10.127,9.121-1.813,16.621-20.056,6.2-15.083-2.44-25.027-10.748-29.967M27.406,53.778c.367-3.1.44-6.2,1.006-9.275.683-3.746,2.127-7.5,2.944-11.277a6.076,6.076,0,0,0,.6,2.319.838.838,0,0,0,1.177.127A15.369,15.369,0,0,0,35.382,33.3c1.729-2.223,1.877,2.006,2.042,2.892.25,1.337.6,2.552,1.844,3.212a1.646,1.646,0,0,0,1.112-.042,5.183,5.183,0,0,1,4.11.079c1.369.54,3.127-.083,4.758-.606a14.012,14.012,0,0,0-1.579,2.773c-1.577,3.1-3.454,6.058-5.283,9.017-.271.36-.538.723-.806,1.079a70.783,70.783,0,0,0-5.135,7.2c-.242.415-.462.863-.675,1.319a22.757,22.757,0,0,0-2.988,4.571l-5.758-2.187c-.588-2.729.06-6.112.381-8.829M58.948,43.451c-3.84,9.346-7.113,10.894-10,12.267-2.563,1.212-5.215,2.467-6.608,7.633-.929,1.169-3.16,3.39-5.165,3.112l-.848-.321c3.087-4.5,6.6-8.665,9.212-13.514,1.742-3.235,4.935-7.562,5.8-11.565a5.973,5.973,0,0,0,1.015-3.76.856.856,0,0,0-.965-.688,11.927,11.927,0,0,0-3.094.617c-2.29.706-4.073-.031-6.277-.5a1.858,1.858,0,0,0-1.262.442c-1.727,1.51-1.971-2.86-2.115-3.623-.171-.908-.517-2.567-1.652-2.748-1.944-.313-2.933,1.408-4.129,2.781-.615-2.2.319-5.5-2.34-6.279a.852.852,0,0,0-1.081.487,7.2,7.2,0,0,0-.379,1.575c-1.021,1.625-1.14,3.867-1.85,5.6a55.916,55.916,0,0,0-3.169,9.815c-.76,3.69-3.525,10.652-3.029,15.539l-.273-.1c-1.687-1.125-1.873-4.26-1.8-5.76,2.394-4.792,1.242-7.487.138-10.09-1.254-2.946-2.671-6.279.665-15.815,5.215-14.894,17.739-14.987,24.89-13.665L49.417,16.7c6.225,3.763,15.525,12.152,9.531,26.748",
    transform: "translate(11.304 10.956)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M36.753,50.495l-.946-.36L15.632,42.466l-1.538-.585a1.592,1.592,0,0,0-1.283.075,1.925,1.925,0,0,0-.912,1.035,1.741,1.741,0,0,0,.9,2.287l2.112.8,19.117,7.265,1.433.546a1.824,1.824,0,0,0,1.288-3.4",
    transform: "translate(10.864 38.566)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M34.133,52.935l-1.071-.408-17.8-6.763-1.871-.712a1.363,1.363,0,0,0-1.181.125,1.968,1.968,0,0,0-.873,1.038,1.686,1.686,0,0,0,.765,2.233l3.652,1.388a10.248,10.248,0,0,0,6.583,6.656s3.515,2.106,7.888-1.156l2.613.992a1.848,1.848,0,0,0,1.29-3.394",
    transform: "translate(10.339 41.511)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M38.415,55.194A27.779,27.779,0,0,0,35.6,49.766a28.016,28.016,0,0,1-1.938-3.394c-.325-.638-1.233-1.979-1.154-2.75a.838.838,0,0,0-1.667-.158c-.183,1.794,1.477,3.981,2.281,5.475a33.608,33.608,0,0,0,1.919,2.956,21.867,21.867,0,0,1,1.846,3.987c.419,1,1.944.308,1.525-.687",
    transform: "translate(28.458 39.446)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M49.677,50.374c-1.837-1.542-3.467-3.371-5.231-5-2.042-1.892-4.64-3.2-6.552-5.221-.738-.781-2.042.267-1.3,1.05a50.136,50.136,0,0,0,6.146,4.858c2.173,1.667,3.86,3.91,5.952,5.667.829.694,1.812-.662.988-1.352",
    transform: "translate(33.574 36.808)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M56.78,39.314c-4.94-1.719-9.692-4.881-14.89-5.79-1.063-.185-1.217,1.483-.16,1.667,5.038.881,9.679,4.025,14.456,5.687,1.017.356,1.615-1.206.594-1.563",
    transform: "translate(37.855 30.931)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M61.566,30.022A69.425,69.425,0,0,1,53.3,28.185c-2.387-.654-5.592-.871-7.688-2.281-.894-.6-1.883.748-.987,1.352a17.473,17.473,0,0,0,5.852,1.95c3.675.767,7.2,1.933,10.929,2.483,1.067.158,1.221-1.512.158-1.667",
    transform: "translate(40.869 23.772)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M62.262,17.194a75.472,75.472,0,0,0-16.467,2.817c-1.017.306-.758,1.962.277,1.65a75.667,75.667,0,0,1,16.467-2.819c1.075-.071.792-1.723-.277-1.648",
    transform: "translate(41.677 15.869)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M58.051,9.481c-5.077,2.848-10.437,4.965-15.381,8.112-.91.581.152,1.875,1.052,1.3,4.825-3.071,10.06-5.11,15.014-7.888.935-.525.256-2.058-.685-1.527",
    transform: "translate(39.067 8.649)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M41.218,2.863c-2.923,3.712-4.444,8.45-7.362,12.112-.673.848.683,1.831,1.354.99,2.921-3.671,4.429-8.4,7.36-12.114.667-.852-.687-1.835-1.352-.988",
    transform: "translate(31.084 2.342)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M28.035,15.293c.806-4.829,2.829-9.485,3.044-14.4C31.125-.182,29.46-.348,29.414.733c-.215,4.906-2.237,9.575-3.044,14.4-.179,1.063,1.49,1.219,1.665.158",
    transform: "translate(24.329 -0.001)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M24.449,17.5c-.775-2.931-2.481-5.508-3.815-8.208A44.171,44.171,0,0,0,14.987.618c-.692-.831-1.992.221-1.3,1.05a45.514,45.514,0,0,1,5.423,8.31c1.292,2.51,2.963,5.056,3.688,7.8.275,1.035,1.929.769,1.652-.277",
    transform: "translate(12.451 0.289)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M21.856,18.508c-5.381-3-10.223-6.773-16.339-8.156-1.048-.237-1.2,1.433-.158,1.667,5.777,1.3,10.431,5.008,15.506,7.838.931.519,1.933-.825.99-1.35",
    transform: "translate(4.292 9.534)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M20.381,22.859c-3.121.15-6.348-.938-9.444-1.3-3.344-.394-6.69-.742-10.044-1.012a.838.838,0,0,0-.158,1.667c3.838.306,7.665.729,11.49,1.179,2.844.335,5.546,1.254,8.433,1.117,1.075-.052.79-1.7-.277-1.652",
    transform: "translate(0 18.963)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M18.368,28.386c-2.183-.479-4.581.362-6.76.631-3.01.373-5.992.94-8.981,1.419A.838.838,0,0,0,2.9,32.088c2.662-.427,5.312-.892,7.977-1.283,2.2-.323,5.162-1.229,7.333-.752,1.05.231,1.2-1.437.158-1.667",
    transform: "translate(1.801 26.069)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M14.451,34.166c-2.623,1.385-5.4,2.44-8.067,3.738-.969.473-.285,2,.685,1.527,2.667-1.3,5.444-2.352,8.069-3.74.95-.5.269-2.031-.687-1.525",
    transform: "translate(5.46 31.444)",
    fill: "#1e61ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.add46a5107e8466f47c80a1b7ebefc10.svg";
export { ForwardRef as ReactComponent };